import { render, staticRenderFns } from "./ManualFormReview.vue?vue&type=template&id=28221bca&scoped=true"
import script from "./ManualFormReview.vue?vue&type=script&lang=js"
export * from "./ManualFormReview.vue?vue&type=script&lang=js"
import style0 from "./ManualFormReview.vue?vue&type=style&index=0&id=28221bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28221bca",
  null
  
)

export default component.exports